import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import '@vant/touch-emulator';
import filters from '@/common/utils/filters'
import directive from '@/common/utils/directive'
import cookie from "js-cookie"

// import "@/mock"; //mock 数据
import {
  Button,
  Tab,
  Tabs,
  Field,
  Cell,
  CellGroup,
  Search,
  DropdownMenu,
  DropdownItem,
  TreeSelect,
  Collapse,
  CollapseItem,
  Switch,
  Icon,
  List,
  NoticeBar,
  Divider,
  Image,
  Popup,
  Uploader,
  Toast,
  PullRefresh,
  Loading,
  Picker,
  ActionSheet,
  Swipe,
  SwipeItem,
  Overlay,
  Checkbox, 
  CheckboxGroup
} from "vant";


Vue.use(Button)
  .use(Tab)
  .use(Tabs)
  .use(Field)
  .use(Cell)
  .use(CellGroup)
  .use(Search)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(TreeSelect)
  .use(Collapse)
  .use(CollapseItem)
  .use(Switch)
  .use(Icon)
  .use(List)
  .use(NoticeBar)
  .use(Divider)
  .use(Image)
  .use(Popup)
  .use(Uploader)
  .use(Toast)
  .use(PullRefresh)
  .use(Loading)
  .use(Picker)
  .use(ActionSheet)
  .use(Swipe)
  .use(SwipeItem)
  .use(Overlay)
  .use(Checkbox)
  .use(CheckboxGroup);

Vue.config.productionTip = false;

if (process.env.NODE_ENV === "production") {
  console.log("build");
}

//根据路由里的meta.title设置每个页面的title
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "";
  if(to.meta.requireAuth){
    if(cookie.get('mp_token')){
      next();
    }else {
      next({
        path:'/account',
        query: {url: to.fullPath}
      })
    }
  }else {
    next();
  }

});


router.afterEach((to, from) => {
  
  if(Object.keys(store.getters['comp/getWxShare']).length){
    
    store.commit('comp/WX_SHARE',{
      link:window.location.href
    });
    //若wxconfig配置好了 分享恢复默认（防止其它页面重置后恢复不了）
  };
})

// 设备进入页面则进行js-sdk签名
// if (window.__wxjs_is_wkwebview === true) {
  



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");